import { takeLatest, all, put, call } from 'redux-saga/effects';

import axios from '../../axiosInstance';
import requests from '../../requests';

import { invitationActionTypes } from './invitation.types';
import {
    invitationVerifySuccess,
    invitationVerifyFailure,
    invitationAcceptSuccess,
    invitationAcceptFailure,
} from './invitation.actions';

// Verify an invitation token and return invitation details.
export function* verifyInvitation({ payload: { token } }) {
    try {
        const { data } = yield axios.get(`${requests.invitationVerify}?token=${token}`);
        yield put(invitationVerifySuccess(data?.data || data));
    } catch (e) {
        const message = e?.response?.data?.message || e?.message || 'Invalid or expired invitation.';
        yield put(invitationVerifyFailure({ message }));
    }
}

// Accept an invitation (requires authenticated session).
export function* acceptInvitation({ payload: { token } }) {
    try {
        const { data } = yield axios.post(requests.invitationAccept, { token });
        yield put(invitationAcceptSuccess());
    } catch (e) {
        const message = e?.response?.data?.message || e?.message || 'Failed to accept invitation.';
        yield put(invitationAcceptFailure({ message }));
    }
}

// Watchers
export function* onVerifyInvitation() {
    yield takeLatest(invitationActionTypes.INVITATION_VERIFY_REQUEST, verifyInvitation);
}

export function* onAcceptInvitation() {
    yield takeLatest(invitationActionTypes.INVITATION_ACCEPT_REQUEST, acceptInvitation);
}

export function* invitationSagas() {
    yield all([
        call(onVerifyInvitation),
        call(onAcceptInvitation),
    ]);
}
